import { PropTypes } from 'prop-types';

import { useNavigate } from 'react-router';

import { theme } from '@prose-ui';
import { ClassNames, css, styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

import { LegacyBaseScene as BaseScene } from 'Scenes/LegacyBaseScene';

const contentOverrideStyles = css`
  background-color: ${theme.colors.primary[400]};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.neutral[100]};
`;

const Description = styled(Typography)`
  margin: 20px 0px;
  max-width: 320px;
`;

const StartStylingGelInterstitial = ({ onNext }) => {
  const navigate = useNavigate();
  return (
    <ClassNames>
      {({ css }) => (
        <BaseScene classes={{ content: css(contentOverrideStyles) }} header relativePosition>
          <Typography variant="mono3">STYLING GEL</Typography>
          <Description align="center" variant="h3">
            Let’s update your profile with four quick questions so we can create your perfect
            formula.
          </Description>
          <Button onClick={onNext} variant="whiteBg">
            continue
          </Button>
          <Button onClick={() => navigate(-1)} variant="underlinedWhite">
            back
          </Button>
        </BaseScene>
      )}
    </ClassNames>
  );
};

StartStylingGelInterstitial.propTypes = {
  onNext: PropTypes.func,
};

StartStylingGelInterstitial.defaultProps = {
  onNext: () => {},
};

export default StartStylingGelInterstitial;
